export default {
	cinema: {
		address: 'пр. Молодежный, д. 2',
		place: null,
		phoneNumbers: ['8 (3842) 56-80-03'],
		facebook: null,
		instagram: null,
		vk: 'https://vk.com/cinemagrinvich',
		twitter: null,
		odnoklassniki: null,
		youtube: null,
		app: {
			appstore: 'https://itunes.apple.com/ru/app/кинотеатр-гринвич/id1287472042?l=ru&ls=1&mt=8',
			googleplay: 'https://play.google.com/store/apps/details?id=ru.kinoplan.cinema.greenvich',
		},
		payment: {
			active: true,
			card: ['mir', 'visa', 'mastercard', 'maestro', 'sbp', 'sberpay'],
		},
		maps: 'https://yandex.ru/maps/-/CBU97Ru4LB',
		selectButton: {
			options: [],
			selectedOptionValue: null,
		},
		soonPageIsEnabled: false,
		saleRules: false,
		details: false,
	},
	feedback: true,
};
